import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { TitleButton } from '@/common/buttons/TitleButton';
import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ValList } from '@/common/val/ValList';
import { useCallback } from 'react';
import { McdUtilLineList } from '../mcdUtilLine/McdUtilLineList';
import { EntityControlList } from '@/common/entities/entityControl/EntityControlList';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';

export const McdUtilDetail = () => {

  const { entityObj } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'utilLines', label: 'Lines', content: <McdUtilLineList mcdUtil={entityObj} /> },
    { id: 'vals', label: 'Validations', content: <ValList parentEntity="MCD_UTIL" parentEntityId={entityObj.id} /> },
    { id: 'soxControlsTab', label: 'SOX Controls', content: <EntityControlList parentEntity="MCD_UTIL" parentEntityId={entityObj.id} /> }
  ];

  const submitToClaims = () => {
    rsrc.store('sc', 'UTIL_CLAIM_STORE_PLUGIN', { entity: 'MCD_UTIL', id: entityObj.id });
  }

  const augButtons = useCallback((buttons) => {
    if (entityObj.status === 'DRAFT' && entityObj.valStatus !== 'NONE' && entityObj.valStatus !== 'CRITICAL') {
      buttons.push(<TitleButton icon={fas.faClipboard} toolTip="Submit to Claims" onClick={submitToClaims} />);
    }
  }, [entityObj.status]);

  return (
    <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
  )
}